import { scenes } from "../scenes";
import { Scene, Choice, Dialog } from "../models";

export class Harbour extends Scene {
  image = require("@/images/Harbour_Exterior.png");
  title = "Harbour";
  get options() {
    return [
      new Choice("Enter Harbour", async () => {
        if (this.state.storylines.infectedWithYogid) {
          this.description = "SONNY YANG: I need to find that SANITIZER!";
          this.audio = require("@/audio/Pandemic-182-Sonny-MP3.mp3")
        } else {
          await this.navigate(scenes.CruiseShipExterior());
        }
      }),
      new Choice("Go Left", async () => await this.navigate(scenes.ShibariHQ())),
      new Choice("Go Right", async () => await this.navigate(scenes.GlennsHouseExterior())),
    ];
  }
}

export default new Harbour();
